(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["home-sales"] && !Shopify.designMode) return;
  try {
    
if ($(window).width() > 750) {
 var winHeight = $("#sales_list7 .grid-view-item").height(); 
    $("#home-sales-bg .sales-code").css("height",winHeight); 
    $(window).resize(function() { 
        winHeight = $("#sales_list7 .grid-view-item").height(); 
        $("#home-sales-bg .sales-code").css("height",winHeight); 
    });
}

  } catch(e) { console.error(e); }
})();
})();
